import React,{useEffect, useRef, useState} from 'react'

import { useSelector } from 'react-redux';
import { auth, submitMsg } from '../../config/firebaseConfig';
import Picker from 'emoji-picker-react';
import { Close, Image, Smile } from '../layout/Icons';
import { serverTimestamp } from 'firebase/firestore';
import escapeAxios from '../../api/axios';
import { msgImgStorage_LINK, UPLOAD_MESSAGE_IMAGE_URL } from '../../api/ApiUrl';

const MsgForm = ({roomId, scrollHere}) => {

    const [value,setValue]=useState('');
    const user=useSelector((state)=>(state.user.value));
    const [showEmoji, setShowEmoji]=useState(false);
    const [imageFile, setImageFile]=useState(null);
    const [imagePreview, setImagePreview]=useState('');
    const [uploading, setUploading]=useState(false);
    const fileInputRef=useRef(null);

    useEffect(()=>{
        if(!imageFile){
            setImagePreview('');
            return;
        }

        const objectUrl=URL.createObjectURL(imageFile);
        setImagePreview(objectUrl);

        return ()=>URL.revokeObjectURL(objectUrl);
    },[imageFile]);

    const sendMsg=async(e)=>{
        e.preventDefault();
        const cleanValue=value.trim();
        if((!cleanValue && !imageFile) || !auth.currentUser || uploading){
            return;
        }

        const uName=`${user.Fname} ${user.Lname}`
        var photoUrl=null
        if(user.image!=null){
            photoUrl=user.image
        }
        const {uid}=auth.currentUser;
        var data={
            createdAt:serverTimestamp(),
            roomId:roomId,
            msg:cleanValue,
            photoUrl:photoUrl,
            uName:uName,
            uid:uid,
            msgType:0,
            read:[user.id]
        }

        try{
            setUploading(true);

            if(imageFile){
                const formData=new FormData();
                formData.append('images[]', imageFile);
                const res=await escapeAxios.post(UPLOAD_MESSAGE_IMAGE_URL, formData, {
                    headers:{
                        'Content-Type':'multipart/form-data',
                    },
                });
                const imageName=res.data.imgNames?.[0];
                data={
                    ...data,
                    msgType:3,
                    imageUrl:imageName ? `${msgImgStorage_LINK}${imageName}` : '',
                    imageName:imageName || imageFile.name,
                    imageSize:imageFile.size,
                }
            }

            await submitMsg(roomId,data)


            setValue('')
            setImageFile(null);
            setShowEmoji(false);
            scrollHere.current.scrollIntoView({behavior:'smooth'})
        }finally{
            setUploading(false);
        }
       
    }
    const appendEmoji=(e, emoji)=>{
        setValue(`${value}${emoji.emoji}`)
    }

    const selectImage=(e)=>{
        const file=e.target.files?.[0];
        e.target.value='';

        if(!file){
            return;
        }

        if(!file.type.startsWith('image/')){
            return;
        }

        if(file.size>8*1024*1024){
            return;
        }

        setImageFile(file);
    }
  return (
    <div className='messenger-composer'>
        {imagePreview &&
        <div className='msg-image-preview'>
            <img src={imagePreview} alt='attachment preview' />
            <div className='msg-image-preview-meta'>
                <span>{imageFile?.name}</span>
                <small>{uploading? 'Uploading' : 'Ready'}</small>
            </div>
            <button type='button' className='msg-image-remove-btn' onClick={()=>setImageFile(null)} disabled={uploading}>
                <Close iconClass={'w-4 h-4'}/>
            </button>
        </div>
        }
        <div className='msg-input-wrapper'>
        <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        className='hidden'
        onChange={selectImage}
        />
        <button type='button' className={`msg-attach-btn ${imageFile? `active` : ``}`} onClick={()=>fileInputRef.current?.click()} disabled={uploading || !auth.currentUser}>
            <Image iconClass={'w-5 h-5'}/>
        </button>
        <form onSubmit={(e)=>sendMsg(e)} className='flex-1 min-w-0'>
        <input
        type="text"
        value={value}
        onChange={(e)=>{setValue(e.target.value)}}
        placeholder={imageFile? 'Add a caption' : 'Aa'}
        className=' msg-input'
        disabled={uploading}
        />
        <button type='submit' className='hidden'>Send</button>
        </form>
        <button type='button' className={`msg-emoji-btn ${showEmoji? `active` : ``}`} onClick={()=>{setShowEmoji(!showEmoji)}}><Smile iconClass={'w-5 h-5'}/></button>
        <button type='button' className='msg-send-btn' onClick={(e)=>sendMsg(e)} disabled={(!value.trim() && !imageFile) || !auth.currentUser || uploading}>{uploading? '...' : 'Send'}</button>
        </div>

     
        <div className={`absolute z-[99] right-0 -top-[35vh] ${showEmoji? `scale-100` : `scale-0`} origin-bottom-right transition-all duration-150 ease-in-out`}>
            <Picker 
            onEmojiClick={appendEmoji} 
            searchPlaceholder={'search emoji'} 
            disableSkinTonePicker={true}
            native={true}/>
        </div>
        
    </div>
  )
}

export default MsgForm
